/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/layout-dashboard
 */
import { default as DefaultIcon } from '~icons/lucide/layout-dashboard';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const LayoutDashboardIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
